import filter from "../../../assets/Services_img/filter.jpg";
export const filterPurificationService = {
  hero: {
    title: "Filter & Purification Media ",
    description:
    "Restoring optimal atmosphere purity and system efficiency for critical glovebox applications.",
    title2:"Replacement",
      imgUrl:filter
  },

  productsDetails: {
    imgList: [
      filter
    ],

    productName: "Filter & Purification Media Replacement",

    description:
      "This service ensures the glovebox purification system operates at peak performance by replacing exhausted filtration and purification media. Our certified engineers replace HEPA filters, activated carbon filters, molecular sieve cartridges, and copper catalyst media to maintain ultra-low oxygen and moisture levels within the glovebox environment.",

    keyFeatures: [
      "HEPA filter inspection and replacement",
      "Activated carbon filter servicing",
      "Molecular sieve cartridge replacement",
      "Copper catalyst purification media renewal",
      "Performance verification for O₂ and H₂O levels",
    ],

    download: {
      title: "Download Service Overview PDF",
      downloadLink: "",
    },

    reviewList: [],
    descriptionTitle:"Service Description",

    briefDescirption:
      "Over time, purification media becomes saturated, reducing glovebox performance and increasing contamination risk. This service restores optimal atmosphere quality, extends system life, and ensures reliable operation for sensitive research and industrial processes.",
  },
};
